import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { toast } from 'sonner';
import { getSettings, updateSettings } from '../services/api';
import { LayoutDashboard, Settings, ExternalLink, Save, Loader2, LogOut } from 'lucide-react';

const AdminLeads = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [configs, setConfigs] = useState({
        phone: '',
        videoUrl: '',
        facebookUrl: '',
        instagramUrl: '',
        email: ''
    });

    const SHEET_URL = 'https://docs.google.com/spreadsheets/d/1RrWDFipQHwCwQ9I-Zea85pLHAErspmhwBUzKaSqeFsE/edit?usp=sharing';

    useEffect(() => {
        if (isAuthenticated) {
            loadConfigs();
        }
    }, [isAuthenticated]);

    const loadConfigs = async () => {
        setLoading(true);
        const result = await getSettings();
        if (result.success) {
            setConfigs(result.config);
        } else {
            toast.error('Erro ao carregar configurações da planilha.');
        }
        setLoading(false);
    };

    const handleLogin = (e) => {
        e.preventDefault();
        if (password === 'marcelo123') {
            setIsAuthenticated(true);
            toast.success('Bem-vindo, Marcelo!');
        } else {
            toast.error('Senha incorreta!');
        }
    };

    const handleUpdateConfigs = async (e) => {
        e.preventDefault();
        setSaving(true);
        const result = await updateSettings(configs);
        if (result.success) {
            toast.success('Configurações salvas com sucesso! (As mudanças podem levar alguns segundos para refletir no site)');
        } else {
            toast.error('Falha ao salvar configurações.');
        }
        setSaving(false);
    };

    if (!isAuthenticated) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#071028] p-4">
                <Card className="w-full max-w-md shadow-2xl border-none">
                    <CardHeader className="space-y-1">
                        <div className="flex justify-center mb-4">
                            <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center">
                                <LayoutDashboard className="w-8 h-8 text-blue-600" />
                            </div>
                        </div>
                        <CardTitle className="text-2xl text-center font-bold">Painel Admin</CardTitle>
                        <CardDescription className="text-center italic text-gray-400">
                            Marcelo Carvalho Transportes
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleLogin} className="space-y-4">
                            <div className="space-y-2">
                                <Input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Senha de acesso"
                                    className="py-6 text-center text-lg"
                                />
                            </div>
                            <Button type="submit" className="w-full py-6 bg-blue-600 hover:bg-blue-700 text-lg font-bold">
                                Entrar
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            {/* Navbar Minimalista */}
            <nav className="bg-white border-b px-8 py-4 flex justify-between items-center sticky top-0 z-10 shadow-sm">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center text-white font-bold">M</div>
                    <span className="font-bold text-gray-800">Admin Panel</span>
                </div>
                <div className="flex gap-4">
                    <Button variant="ghost" className="text-gray-500" onClick={() => window.open('/', '_blank')}>
                        Ver Site <ExternalLink className="ml-2 w-4 h-4" />
                    </Button>
                    <Button variant="outline" size="icon" onClick={() => setIsAuthenticated(false)}>
                        <LogOut className="w-4 h-4" />
                    </Button>
                </div>
            </nav>

            <main className="flex-1 p-8 max-w-5xl mx-auto w-full">
                <Tabs defaultValue="leads" className="space-y-6">
                    <TabsList className="grid grid-cols-2 w-full max-w-md mx-auto h-12 bg-white border">
                        <TabsTrigger value="leads" className="flex gap-2">
                            <LayoutDashboard className="w-4 h-4" /> Leads
                        </TabsTrigger>
                        <TabsTrigger value="settings" className="flex gap-2">
                            <Settings className="w-4 h-4" /> Configs
                        </TabsTrigger>
                    </TabsList>

                    <TabsContent value="leads">
                        <Card className="border-none shadow-md overflow-hidden">
                            <CardHeader className="bg-white border-b">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <CardTitle>Gestão de Leads</CardTitle>
                                        <CardDescription>Todos os orçamentos recebidos via formulário</CardDescription>
                                    </div>
                                    <Button onClick={() => window.open(SHEET_URL, '_blank')} className="bg-green-600 hover:bg-green-700">
                                        Aceder Google Sheets <ExternalLink className="ml-2 w-4 h-4" />
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardContent className="p-0">
                                <div className="p-12 text-center">
                                    <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/3/30/Google_Sheets_logo_%282014-2020%29.svg" className="w-10" alt="Sheets" />
                                    </div>
                                    <h3 className="text-xl font-bold mb-2">Central de Leads no Google Sheets</h3>
                                    <p className="text-gray-500 max-w-md mx-auto mb-6">
                                        Seus leads estão salvos com segurança na planilha. Clique no botão acima para ver detalhes, exportar ou gerenciar o funil.
                                    </p>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
                                        <div className="p-4 bg-blue-50 rounded-xl">
                                            <p className="text-blue-600 font-bold">100%</p>
                                            <p className="text-xs text-blue-400">Confiável</p>
                                        </div>
                                        <div className="p-4 bg-green-50 rounded-xl">
                                            <p className="text-green-600 font-bold">Direto</p>
                                            <p className="text-xs text-green-400">P/ WhatsApp</p>
                                        </div>
                                        <div className="p-4 bg-orange-50 rounded-xl">
                                            <p className="text-orange-600 font-bold">Cloud</p>
                                            <p className="text-xs text-orange-400">Acesso Mobile</p>
                                        </div>
                                        <div className="p-4 bg-purple-50 rounded-xl">
                                            <p className="text-purple-600 font-bold">Grátis</p>
                                            <p className="text-xs text-purple-400">P/ Sempre</p>
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </TabsContent>

                    <TabsContent value="settings">
                        <Card className="border-none shadow-md">
                            <CardHeader>
                                <CardTitle>Configurações do Site</CardTitle>
                                <CardDescription>Altere links e informações que aparecem no site instantaneamente</CardDescription>
                            </CardHeader>
                            <CardContent>
                                {loading ? (
                                    <div className="flex flex-col items-center justify-center py-12">
                                        <Loader2 className="w-10 h-10 animate-spin text-blue-600 mb-4" />
                                        <p className="text-gray-500">Buscando dados da planilha...</p>
                                    </div>
                                ) : (
                                    <form onSubmit={handleUpdateConfigs} className="space-y-6">
                                        <div className="grid md:grid-cols-2 gap-6">
                                            <div className="space-y-2">
                                                <label className="text-sm font-semibold text-gray-700">Telefone de Contato (WhatsApp)</label>
                                                <Input
                                                    value={configs.phone || ''}
                                                    onChange={(e) => setConfigs({ ...configs, phone: e.target.value })}
                                                    placeholder="+351 937 603 706"
                                                />
                                            </div>
                                            <div className="space-y-2">
                                                <label className="text-sm font-semibold text-gray-700">Email da Empresa</label>
                                                <Input
                                                    value={configs.email || ''}
                                                    onChange={(e) => setConfigs({ ...configs, email: e.target.value })}
                                                    placeholder="exemplo@gmail.com"
                                                />
                                            </div>
                                            <div className="space-y-2 md:col-span-2">
                                                <label className="text-sm font-semibold text-gray-700">URL do Vídeo (YouTube Embed)</label>
                                                <Input
                                                    value={configs.videoUrl || ''}
                                                    onChange={(e) => setConfigs({ ...configs, videoUrl: e.target.value })}
                                                    placeholder="https://www.youtube.com/embed/..."
                                                />
                                                <p className="text-xs text-gray-400 italic">Use o link de "Incorporar" (embed) para o vídeo aparecer corretamente.</p>
                                            </div>
                                            <div className="space-y-2">
                                                <label className="text-sm font-semibold text-gray-700">Link Facebook</label>
                                                <Input
                                                    value={configs.facebookUrl || ''}
                                                    onChange={(e) => setConfigs({ ...configs, facebookUrl: e.target.value })}
                                                />
                                            </div>
                                            <div className="space-y-2">
                                                <label className="text-sm font-semibold text-gray-700">Link Instagram</label>
                                                <Input
                                                    value={configs.instagramUrl || ''}
                                                    onChange={(e) => setConfigs({ ...configs, instagramUrl: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        <div className="pt-6 border-t flex justify-end">
                                            <Button type="submit" size="lg" disabled={saving} className="px-8 bg-blue-600">
                                                {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
                                                Salvar Alterações
                                            </Button>
                                        </div>
                                    </form>
                                )}
                            </CardContent>
                        </Card>
                    </TabsContent>
                </Tabs>
            </main>

            <footer className="py-6 text-center text-gray-400 text-sm">
                Marcelo Carvalho Control Center • v2.0 Sheets powered
            </footer>
        </div>
    );
};

export default AdminLeads;
